import { defineComponent, ref, createElementBlock, openBlock, renderSlot, Fragment, createElementVNode, createVNode } from 'vue';
import _sfc_main$1 from './basler-components.es85.js';
/* empty css                       */

const _hoisted_1 = { class: "filter-box__header" };
const _hoisted_2 = { class: "filter-box__content" };
const _hoisted_3 = { class: "accordion is-loading-skeleton" };
const _hoisted_4 = { class: "accordion-item" };
const _hoisted_5 = { class: "accordion-item__header" };
const _hoisted_6 = { class: "accordion-item__panel is-active" };
const _hoisted_7 = { class: "accordion-item__panel-inner" };
const _hoisted_8 = { class: "accordion-item__content" };
const _hoisted_9 = { class: "filter-box__list-loading-skeleton" };
const _hoisted_10 = { class: "accordion-item" };
const _hoisted_11 = { class: "accordion-item__header" };
const _hoisted_12 = { class: "accordion-item" };
const _hoisted_13 = { class: "accordion-item__header" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "FilterBox",
  props: {
    isLoading: { type: Boolean, default: false }
  },
  setup(__props) {
    const filterbox = ref(null);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "filterbox",
        ref: filterbox,
        class: "filter-box"
      }, [
        _ctx.isLoading ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          createElementVNode("div", _hoisted_1, [
            createVNode(_sfc_main$1, {
              type: "button",
              style: { "width": "100%" }
            })
          ]),
          createElementVNode("div", _hoisted_2, [
            createElementVNode("div", _hoisted_3, [
              createElementVNode("div", _hoisted_4, [
                createElementVNode("div", _hoisted_5, [
                  createVNode(_sfc_main$1, {
                    type: "block",
                    style: { "width": "90%" }
                  })
                ]),
                createElementVNode("div", _hoisted_6, [
                  createElementVNode("div", _hoisted_7, [
                    createElementVNode("div", _hoisted_8, [
                      createElementVNode("ul", _hoisted_9, [
                        createElementVNode("li", null, [
                          createVNode(_sfc_main$1, { style: { "width": "85%", "height": "20px" } })
                        ]),
                        createElementVNode("li", null, [
                          createVNode(_sfc_main$1, { style: { "width": "65%", "height": "20px" } })
                        ]),
                        createElementVNode("li", null, [
                          createVNode(_sfc_main$1, { style: { "width": "75%", "height": "20px" } })
                        ]),
                        createElementVNode("li", null, [
                          createVNode(_sfc_main$1, { style: { "width": "60%", "height": "20px" } })
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              createElementVNode("div", _hoisted_10, [
                createElementVNode("div", _hoisted_11, [
                  createVNode(_sfc_main$1, {
                    type: "block",
                    style: { "width": "70%" }
                  })
                ])
              ]),
              createElementVNode("div", _hoisted_12, [
                createElementVNode("div", _hoisted_13, [
                  createVNode(_sfc_main$1, {
                    type: "block",
                    style: { "width": "75%" }
                  })
                ])
              ])
            ])
          ])
        ], 64)) : renderSlot(_ctx.$slots, "default", { key: 1 })
      ], 512);
    };
  }
});

export { _sfc_main as default };
